var React = require('react');

function ArrowNormalDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#D4212C","fillRule":"nonzero"},React.createElement("g",null,React.createElement("path",{"d":"M12.642.651c.192-.198.509-.202.707-.01.176.172.199.44.066.638l-.057.07-5.717 5.879c-.168.174-.4.272-.641.272-.201 0-.395-.068-.552-.192l-.09-.08-5.716-5.88C.449 1.152.453.835.652.643c.175-.172.445-.187.638-.05l.068.06L7 6.451l5.642-5.8z","transform":"translate(1 4)"})))));
}

ArrowNormalDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ArrowNormalDown;

ArrowNormalDown.default = ArrowNormalDown;
